import { PaginationType } from "@/types"
import { apiFetch } from "../utils"
import { postActivityLog } from "./log"
import { ServiceRequestHistoryType } from "@/types/service-request-history"
const billingUrl = `himo-billing/`

export async function getServiceRequestHistory(
  consumerId: number,
  startDate: string,
  endDate: string,
  size: number,
  page: number,
  search: string,
): Promise<PaginationType<ServiceRequestHistoryType>> {
  const response = await apiFetch(
    `${billingUrl}service-requests-history/?consumer_id=${consumerId}&from_date=${startDate}&to_date=${endDate}&size=${size}&page=${page}&search=${search}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    },
  )
   const jsonResponse = await response.json()
    console.log("jsonResponse: ",jsonResponse)
  if (!response.ok) {
    throw new Error(`Error fetching service request history: ${response.statusText}`)
  }
   
  return jsonResponse
}